// src/services/employeeService.js
import { api } from './api';

export const employeeService = {
  getEmployees: (department, status, search) => {
    const params = new URLSearchParams();
    if (department) params.append('department', department);
    if (status) params.append('status', status);
    if (search) params.append('search', search);
    const qs = params.toString();
    return api.get('/api/employees/' + (qs ? '?' + qs : ''));
  },

  getEmployee: (employeeId) =>
    api.get('/api/employees/' + employeeId),

  createEmployee: (data) =>
    api.post('/api/employees/', data),

  updateEmployee: (employeeId, data) =>
    api.put('/api/employees/' + employeeId, data),

  deleteEmployee: (employeeId) =>
    api.delete('/api/employees/' + employeeId),

  enrollFace: (employeeId, images) =>
    api.post('/api/employees/' + employeeId + '/enroll-face', { images }),

  getDepartments: async () => {
    try {
      const token = localStorage.getItem('access_token');
      console.log('Token exists:', !!token);
      console.log('Calling /api/departments/');
      
      const result = await api.get('/api/departments/');
      console.log('Departments fetched successfully:', result);
      return result;
    } catch (error) {
      console.error('Department fetch error:', error);
      console.error('Error status:', error.status);
      console.error('Error message:', error.message);
      
      // Fallback: try without auth if 401
      if (error.status === 401) {
        console.log('Got 401, trying without auth...');
        try {
          const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
          const response = await fetch(baseUrl + '/api/departments/', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
          });
          if (response.ok) {
            return await response.json();
          }
        } catch (fallbackError) {
          console.error('Fallback also failed:', fallbackError);
        }
      }
      throw error;
    }
  },

  createDepartment: (data) =>
    api.post('/api/departments/', data),

  getAttendanceHistory: (employeeId, month, year) => {
    const params = new URLSearchParams();
    if (month) params.append('month', month);
    if (year) params.append('year', year);
    const qs = params.toString();
    return api.get('/api/attendance/employee/' + employeeId + (qs ? '?' + qs : ''));
  },

  getDocBlob: (employeeId, docType) => {
    const token = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    return fetch(baseUrl + '/api/employees/' + employeeId + '/document/' + docType + '?token=' + token);
  },

  getAttendanceSummary: (employeeId, month, year) =>
    api.get('/api/attendance/employee/' + employeeId + '/summary?month=' + month + '&year=' + year),

  getEmployeeLeaves: (employeeId) =>
    api.get('/api/leaves/employee/' + employeeId),

  getLeaveBalance: (employeeId, year) =>
    api.get('/api/leaves/balance/' + employeeId + (year ? '?year=' + year : '')),

  getEmployeeAssets: (employeeId) =>
    api.get('/api/assets/?assigned_to=' + encodeURIComponent(employeeId)),

  getAssets: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get('/api/assets/' + (qs ? '?' + qs : ''));
  },

  // Feature: Employee Document Vault (PDF/Image uploads, Admin/HR only)
  getEmployeeDocuments: (employeeId) =>
    api.get('/api/employees/' + employeeId + '/documents'),

  uploadEmployeeDocument: (employeeId, data) =>
    api.post('/api/employees/' + employeeId + '/documents', data),

  deleteEmployeeDocument: (employeeId, documentId) =>
    api.delete('/api/employees/' + employeeId + '/documents/' + documentId),

  // Downloads via fetch (needs the Authorization header, so a plain <a href> won't work)
  downloadEmployeeDocument: async (employeeId, documentId, filename) => {
    const token = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    const response = await fetch(
      baseUrl + '/api/employees/' + employeeId + '/documents/' + documentId + '/download',
      { headers: { Authorization: 'Bearer ' + token } }
    );
    if (!response.ok) {
      throw new Error('Failed to download document');
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'document';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  getPreviewUrl: (employeeId, documentId) => {
    const token = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    return (
      baseUrl + '/api/employees/' + employeeId + '/documents/' + documentId +
      '/download?preview=1&token=' + encodeURIComponent(token)
    );
  },
};